import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from "@mui/material"
import { ProductoColaboradorDTO } from "../../interfaces/ColaboradorProdcutoDTO"
import { ObjetoLabelFilter } from "../../interfaces/ObjetoLabel";
import { useEffect, useState } from "react";
import CatalogService from "../../services/CatalogService";

interface Props{
    listColaboradores: Array<ProductoColaboradorDTO>
    idinvestigador: number,
    token: any,
    ready: boolean,
    onResponse?: (dataRespuesta: Array<ProductoColaboradorDTO>) => void // Función para pasar la respuesta al padre
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const catalogService = new CatalogService();

export default function TableColProducto(prop:Props) {
    const [listRolColaborador,setListRolColaborador] = useState<Array<ObjetoLabelFilter>>([])

    //#region Use Effect
    useEffect(() => {
        fetchData();
        },[]);
    //#endregion
    //#region Function
    const fetchData = async () =>{
        try{               
          setListRolColaborador(catalogService.getRolColaboradorProducto)                 
        }catch(error){
          console.error('Error:',error);
        }
      };
    //#endregion
    return(
        <Grid>
        <strong>Colaboradores:</strong>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>Identificación</StyledTableCell>
                              <StyledTableCell>Nombre</StyledTableCell>
                              <StyledTableCell>Participación</StyledTableCell>
                              <StyledTableCell>Institución</StyledTableCell>
                              <StyledTableCell>Correo</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {prop.listColaboradores.map((row) => (
                              <StyledTableRow key={row.cedula}>
                                <StyledTableCell component="th" scope="row">
                                  {row.cedula}
                                </StyledTableCell>
                                <StyledTableCell>{row.nombre}</StyledTableCell>
                                <StyledTableCell>{row.tipoparticipacion != null ? listRolColaborador.find(x => x.id == row.tipoparticipacion)?.label : row.tipoparticipacion}</StyledTableCell>
                                <StyledTableCell>{row.institucion}</StyledTableCell>
                                <StyledTableCell>{row.email}</StyledTableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
        </Grid>
    )
}